import { cn } from "@theprelude/core";
import { useId } from "react";

export const ServiceNowIcon: React.FC<
  React.ComponentPropsWithoutRef<"svg">
> = ({ className, ...props }) => {
  const clipPathId = useId();

  return (
    <svg
      className={cn("size-4 flex-shrink-0", className)}
      {...props}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath={`url(#${clipPathId})`}>
        <path
          d="M24 13.2861C23.9456 16.6412 22.7638 19.4978 20.4147 21.8614C19.4396 22.842 18.1998 22.9363 17.0814 22.1532C13.9257 19.9437 10.0377 19.9383 6.92736 22.1387C5.78544 22.9453 4.65802 22.8493 3.59947 21.8524C-1.60986 16.9548 -1.08603 8.02242 4.65983 3.74837C12.2273 -1.88149 22.4593 2.34543 23.8912 11.6965C23.9728 12.2276 23.9674 12.7714 24 13.2861ZM11.8775 19.2459C15.2561 19.3129 17.917 16.8315 18.0022 13.529C18.0928 9.98906 15.6313 7.34995 12.1512 7.25932C8.73812 7.17051 6.04645 9.68455 5.97757 13.0233C5.90507 16.5578 8.3883 19.1752 11.8775 19.2459Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.213257)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
